import React from "react";
import { Phone, MessageCircle, MapPin, Clock, ShieldCheck } from "lucide-react";
import "./CameraSection.css";
import img from '../../../assets/imm.png'

const CameraSection = () => {
  return (
    <section className="camera-section">
      <div className="container">
        <div className="text-content">
          <h1>Secure Your <span>Home & Business</span></h1>
          <p className="desc">
            We provide <strong>sales</strong>, <strong>professional installation</strong>,
            <strong> maintenance</strong> and <strong>on-site service</strong> for Servers,
            Surveillance, Wireless Access Point, across <strong>Bengaluru</strong>.
          </p>

          <div className="cta-buttons">
            <a href="tel:+919538777965" className="btn primary">
              <Phone size={18} /> Call Now
            </a>
            <a
              href="https://wa.me/9538777965"
              target="_blank"
              rel="noopener noreferrer"
              className="btn whatsapp"
            >
              <MessageCircle size={18} /> WhatsApp
            </a>
            {/* <a href="#quote" className="btn outline">
              Get a Quote
            </a> */}
          </div>

          <div className="info">
            <p><MapPin size={16} /> 891, 7th Main Rd, Prakash Nagar, Rajajinagar, Bengaluru, Karnataka 560021</p>
            <p><Clock size={16} /> Mon - Sat: 9:30 AM - 7:00 PM</p>
          </div>
        </div>

        <div className="image-content">
          <img
            src={img}
            alt="CCTV installation"
          />
          <div className="tag">
            <ShieldCheck size={16} /> Professional Installation
          </div>
        </div>
      </div>
    </section>
  );
};

export default CameraSection;
